
import * as type from './types';

export function getNewServices(data) {
    return {
        type: type.GET_NEW_SERVICES_REQUESTED,
        data: data,
    }
};